// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
//import VueI18n from 'vue-i18n'
import App from './App'
import router from './router'
import bootstrap from 'bootstrap'
import 'nprogress/nprogress.css';

require('./assets/sass/app.scss');

// ES6 polyfill for Promise.prototype.finally()
window.Promise.prototype.finally = function finallyPolyfill(callback) {
    var constructor = this.constructor;

    return this.then(function(value) {
            return constructor.resolve(callback()).then(function() {
                return value;
            });
        }).catch(function(reason) {
            return constructor.resolve(callback()).then(function() {
                throw reason;
            });
        });
};

// change with the API host
window.apiHost = "https://api.beetronix.com";
window.NProgress = require("nprogress");

const messages = {
    ar: {
        home: 'الرئيسية',
        ourProducts: 'منجاتنا',
        priceOrder: 'طلب نسعير',
        newsAndActivities: 'الأخبار و الأنشطة',
        technicalSupport: 'الدعم الفني',
        contactUs: 'اتصل بنا',
        joinUs: 'انضم لنا',
        aboutUs: 'حول الشركة'
    },
    en: {
        home: 'Home',
        ourProducts: 'Our Products',
        priceOrder: 'Price Order',
        newsAndActivities: 'News & Activities',
        technicalSupport: 'Technical Support',
        contacUs: 'Contact Us',
        joinUs: 'Join Us',
        aboutUs: 'About Us',
    }
};

window.axios = require('axios');

window.axios.defaults.headers.common = {
    'Accept': 'application/json',
};

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
    NProgress.start();
    next();
});

router.afterEach((to, from) => {
    NProgress.done();
    $('html, body').animate({ scrollTop: 0 }, 500);
    $('.navbar-collapse').removeClass('in');
});

Vue.mixin({
    methods: require("./mixins.js")
});

/* eslint-disable no-new */
new Vue({
        //i18n,
        el: '#app',
        router,
        template: '<App/>',
        components: { App }
    }) //.$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js